import React from 'react'
import { Switch, withRouter, Route, Redirect } from 'react-router-dom'
import ProtectedRoute from './ProtectedRoute'
import Dashboard from 'container/Dashboard'
import BrokerDashboardContainer from 'container/BrokerDashboard'
import UnderwriterDashboardContainer from 'container/UnderwriterDashboard'
import SearchApplicants from 'container/Applicant/searchApplicant'
import CreateApplicant from 'container/Applicant/createApplicationContainer'
import ApplicantDetail from 'container/Applicant/applicantDetail'
import ApplicationOffersContainer from 'container/ApplicationOffers'
import ApplicationOfferDetailContainer from 'container/ApplicationOffers/ApplicationOfferDetailContainer'
import client from 'container/Applicant/client'
import MonitoringContainer from 'container/Monitoring/monitoring'
import QuickSearch from 'container/QuickSearch'
import ClientProfileContainer from 'container/RoxAdminContainer/ClientProfileContainer'
import Profile from 'container/Profile'
import Page404 from 'components/Page404'
import { Notification } from "components/Notification"
import EmailLog from 'container/EmailLog'
import AuthService from "../tools/AuthService";
import DesignSystem from 'components/DesignSystem'

// Sales reps only see the applications shared with them, and their profile
const SalesRepRoutes = () => (
    <Switch>
        <ProtectedRoute exact isAuth={true} path='/applicants/:clientUUID?' component={SearchApplicants} />
        <ProtectedRoute exact isAuth={true} path='/applicant/:applicantUUID?' component={ApplicantDetail} />
        <ProtectedRoute exact isAuth={true} path='/profile' component={Profile} />
        <Route render={() => <Redirect to='/applicants' />} />
    </Switch>
)

const RoutesRoot = () => {
        const { gmailPdfImportEnabled, isReadOnlyUser, activityDashboardEnabled } = AuthService.getClientFeatures()
    if (AuthService.isSalesRep()) {
        return <SalesRepRoutes />
    }
    return (
        <Switch>
            <ProtectedRoute
                exact
                isAuth={true}
                path='/dashboard'
                component={Dashboard}
            />
            <ProtectedRoute
                exact
                isAuth={true}
                path='/broker-portal'
                component={BrokerDashboardContainer}
            />
            <Route
                exact
                path='/underwriter-dashboard'
                render={(props) => activityDashboardEnabled
                    ? <UnderwriterDashboardContainer {...props} />
                    : <Redirect to='/dashboard' />}
            />
            <ProtectedRoute
                exact
                isAuth={true}
                path='/applicants/:clientUUID?'
                component={SearchApplicants}
            />
            <ProtectedRoute
                exact
                isAuth={true}
                path='/application-offers'
                component={ApplicationOffersContainer}
            />
            <ProtectedRoute
                exact
                isAuth={true}
                path='/applicant-offer/:roxMatchId'
                component={ApplicationOfferDetailContainer}
            />
            <ProtectedRoute
                exact
                isAuth={true}
                path='/applicant/:applicantUUID?'
                component={ApplicantDetail}
            />
            <ProtectedRoute
                exact
                isAuth={true}
                path='/create-applicant/:clientUUID?'
                component={CreateApplicant}
            />
            <ProtectedRoute
                exact
                isAuth={true}
                path='/settings/:tab?'
                component={ClientProfileContainer}
            />
                <ProtectedRoute
                    exact
                    isAuth={true}
                    path='/settings/showConfirmation/:subConfirmation'
                    component={ClientProfileContainer}
                />
            <ProtectedRoute
                exact
                isAuth={true}
                path='/profile'
                component={Profile}
            />
            <ProtectedRoute
                exact
                isAuth={true}
                path="/ucc"
                component={client}
            />
            <ProtectedRoute
                exact
                isAuth={true}
                path="/monitoring"
                component={MonitoringContainer}
            />
            <ProtectedRoute
                exact
                isAuth={!isReadOnlyUser}
                path="/quick-search"
                component={QuickSearch}
            />
            <ProtectedRoute
                exact
                isAuth={true}
                path="/notifications"
                component={Notification}
            />
            <ProtectedRoute
                exact
                isAuth={gmailPdfImportEnabled}
                path="/email-logs"
                component={EmailLog}
            />
            {}
            {/* <ProtectedRoute
                exact
                isAuth={true}
                path='/design-system'
                component={DesignSystem}
            /> */}
            <Route render={props => <Page404 {...props} />} />
        </Switch>
    )
}

export default withRouter(RoutesRoot)
